import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { analogous, rgb2css, rgb2hex } from './conversion-functions';
import { useHistory } from 'react-router-dom';

const ColorAnalogous = ({ hex }) => {
  const history = useHistory();
  const onClick = (c) => {
    let colorhex = rgb2hex(c);
    if (colorhex.substring(0, 1) === '#') {
      colorhex = colorhex.substring(1);
    }
    let url = '/hex/' + colorhex;
    history.push(url);
  };
  const analogouscolors = analogous(hex);
  return (
    <div className='card mt-3'>
      <div className='card-header'>
        <h2>Analogous Colors with {'#' + hex}</h2>
      </div>
      <div className='card-body'>
        <div className='row'>
          <div className='d-none d-sm-block col-sm-1' style={{ width: '12.499999995%', flex: '0 0 12.499%', maxWidth: '12.499%' }}></div>
          {analogouscolors.map((c, key) => (
            <Fragment key={key}>
              <div className='col-md-3 text-center'>
                <div style={{ height: 150 + 'px', backgroundColor: rgb2css(c), position: 'relative', cursor: 'pointer' }} onClick={() => onClick(c)}></div>
                <div>{rgb2css(c)}</div>
                <div>{rgb2hex(c)}</div>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

ColorAnalogous.propTypes = {
  hex: PropTypes.string.isRequired,
};

export default ColorAnalogous;
